import { styled } from '@mui/material'
import { NavLink } from '@/presentation/components/atoms/navLink'

export const StyledNavLink = styled(NavLink)(({ theme }) => ({
  /*   display: "block",
  height: 64,
  margin: "8px 0",
  color: theme.palette.grey[700] */
}))
